import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { ButtonComponent } from '@sirius/common';

@Component({
    selector: 'matchmaking-form-back-button',
    imports: [ButtonComponent],
    templateUrl: './form-back-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-back-button.component.scss'
})
export class FormBackButtonComponent {
    @Input()
    text!: string;

    @Output()
    clicked = new EventEmitter();

    clickedBack() {
        this.clicked.emit();
    }
}
